import { APP_INITIALIZE_REQUESTED } from "../constants/appConstants";
import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  AUTHENTICATE_USER_SUCCESS,
  AUTHENTICATE_USER_FAILURE,
  AUTHENTICATE_USER_REQUESTED,
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE
} from "../constants/authConstants";
import { getLocalStorage } from "../../helpers/storage";

const initialState = {
  token: getLocalStorage('token'),
  error: null,
  loading: true,
  isAuthenticated: false,
  refreshToken: getLocalStorage('refreshToken'),
  resourceAccess: [],
  email: null
};

const authReducer = (state = initialState, action) => {
  const { data, type } = action;
  switch (type) {
    case APP_INITIALIZE_REQUESTED:
    case LOGIN_REQUEST:
    case AUTHENTICATE_USER_REQUESTED:
    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        isAuthenticated: true,
      };
    case REGISTER_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        isAuthenticated: false,
      };
    case AUTHENTICATE_USER_SUCCESS:
      return {
        ...state,
        email:data.email,
        isAuthenticated: true,
        error: null,
        loading: false,
        token: data.token,
        refreshToken: data.refreshToken,
        resourceAccess: data.resourceAccess
      };
    case LOGIN_FAILURE:
    case AUTHENTICATE_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        isAuthenticated: false,
        token: null,
        refreshToken: null,
        email: null
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case REGISTER_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default authReducer;